import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { LocalizationService } from "../../../common/services/localization";

@Component({
    selector: "root",
    template: require("./root.component.html").default,
    styles: [require("../../../common/styles/index.scss").default, require("./root.component.scss").default],
    encapsulation: ViewEncapsulation.None, // Allow root styles to apply to parent
})
export class RootComponent {
    constructor(
        private _i18n: LocalizationService,
        @Inject("localeCode") private _localeCode: string,
    ) {
        this._i18n.setLocale(_localeCode);
    }
}
